import DocEventSearchRoot from "./doc-event-search/doc-event-search-root";
import {authRoles} from "../../auth/authRoles";

const docEventRoutes = [
  {
    path: "/document-event",
    element: <DocEventSearchRoot />,
    auth: authRoles.admin,
  },
];

export default docEventRoutes;
